<h1 mat-dialog-title>
    <div [style.font-size.px]="media.isActive('lt-sm') ? '16' : ''">
      {{ 'LABEL_FILTER' | translate }}
    </div>
  </h1>
  
  <div mat-dialog-content fxLayout="column" fxAlign="center center">
    <div fxLayout="column" fxLayoutGap="20px">
  
      <form [formGroup]="formGroup" novalidate autocomplete="off" autocorrect="off">
  
        <!-- dates -->
        <div fxLayout="column">
          <p class="sub-header">
            {{ 'LABEL_SETTLEMENT_DATE' | translate }}
          </p>
  
          <div fxLayout fxLayoutGap="20px">
            <!-- fromMonth -->
            <mat-form-field fxFlex>
              <input 
                readonly
                matInput 
                (click)="fromMonthPicker.open()" 
                [matDatepicker]="fromMonthPicker" 
                [max]="tempToMonth" 
                formControlName="fromMonth" 
                [placeholder]="'LABEL_FROM_MONTH' | translate"  
                >

              <mat-datepicker-toggle 
                matSuffix 
                [for]="fromMonthPicker"
                >
              </mat-datepicker-toggle>

              <mat-datepicker 
                #fromMonthPicker 
                startView="multi-year" 
                panelClass="example-month-picker"
                (yearSelected)="chosenYearHandler($event, 'fromMonth')" 
                (monthSelected)="chosenMonthHandler($event, fromMonthPicker, 'fromMonth')"
                >
              </mat-datepicker>     
            </mat-form-field>

            <span fxFlex="5"></span>

            <!-- toMonth -->
            <mat-form-field fxFlex>
              <input 
                readonly
                matInput 
                formControlName="toMonth"
                [min]="tempFromMonth" 
                [max]="defaultEndDate"
                (click)="toMonthPicker.open()"
                [matDatepicker]="toMonthPicker" 
                [placeholder]="'LABEL_TO_MONTH' | translate" 
                >

              <mat-datepicker-toggle 
                matSuffix 
                [for]="toMonthPicker"
                >
              </mat-datepicker-toggle>

              <mat-datepicker 
                #toMonthPicker 
                startView="multi-year"  
                panelClass="example-month-picker"
                (yearSelected)="chosenYearHandler($event, 'toMonth')" 
                (monthSelected)="chosenMonthHandler($event, toMonthPicker, 'toMonth')" 
                >
              </mat-datepicker> 
            </mat-form-field>
          </div>
        </div>
  
        <!-- campaign -->
      <mat-form-field class="width-100">
        <input 
          matInput
          required
          #campaignInput
          formControlName="campaign" 
          [matAutocomplete]="campaignAC"
          [placeholder]="'LABEL_CAMPAIGN' | translate" 
          (focus)="!campaignAC.isOpen && getInitialData('campaign')"
          >
    
        <mat-icon 
          matSuffix 
          color="primary"
          class="clear-input"
          svgIcon="close-circle"
          *ngIf="campaignInput.value"
          (click)="resetControl(formGroup.get('campaign')); campaignInput.value = ''"
          >
        </mat-icon>
    
        <mat-icon 
          matSuffix 
          class="clear-input"
          svgIcon="menu-down"
          *ngIf="!campaignInput.value"
          >
        </mat-icon>
    
        <mat-autocomplete 
          [displayWith]="displayFn"
          #campaignAC="matAutocomplete" 
          (closed)="campaignInput.blur()"
          (opened)="autocompleteScroll('campaign','campaignACRef','campaignACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.campaign && filterOptions.campaign?.length == 0"
            >
            {{ 'MSG_NO_DATA' | translate }}
          </mat-option>
    
          <mat-option *ngFor="let item of filterOptions.campaign" [value]="item">
            {{ item.description }}
          </mat-option>
    
          <mat-option *ngIf="loading.campaign" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>
    
        <mat-error *ngIf="formGroup.controls['campaign'].hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>   

        <mat-error *ngIf="formGroup.controls['campaign'].hasError('notExisting')">
            {{ 'MSG_DOESNT_EXIST' | translate: {type: ('LABEL_CAMPAIGN' | translate)} }}
        </mat-error>
      </mat-form-field>

      <!-- distribution -->
      <mat-form-field class="width-100">
        <mat-chip-list #chipsDistribution aria-label="Distribution">
          <mat-chip *ngFor="let data of multiSelect.selectedDistributions" [removable]="true" (removed)="toggleSelection(data, filterOptions.distribution, 'selectedDistributions', 'distribution')">
            {{data.description}}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        
          <input 
            matInput
            #distributionInput 
            [matChipInputFor]="chipsDistribution" 
            formControlName="distribution" 
            [matChipInputAddOnBlur]="true"
            [matAutocomplete]="distributionAC" 
            (focus)="getInitialData('distribution')" 
            (blur)="checkAutocompleteObject(formGroup, 'distribution', 'selectedDistributions')"
            [placeholder]="'LABEL_DISTRIBUTION' | translate" 
            >
        
          <mat-icon 
            matSuffix 
            svgIcon="menu-down" 
            *ngIf="!distributionInput.value" 
            class="autocomplete-arrow-color cursor-pointer"
            (click)="distributionInput.focus()" 
            >
          </mat-icon>
        </mat-chip-list>
        
        <mat-autocomplete 
          [displayWith]="displayFn"
          #distributionAC="matAutocomplete" 
          (opened)="autocompleteScroll('distribution','distributionACRef','distributionACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.distribution && filterOptions.distribution?.length == 0"
            >
            {{ 'MSG_NO_DATA' | translate }}
          </mat-option>

          <ng-container>
            <mat-option *ngFor="let data of filterOptions.distribution" [value]="data" [disabled]="data.disabled">
              <div (click)="!data.disabled && optionClicked($event, data, filterOptions.distribution, 'selectedDistributions', 'distribution', distributionInput)" [class.disable]="data.disabled">
                <mat-checkbox [checked]="data.selected" (change)="toggleSelection(data, filterOptions.distribution, 'selectedDistributions', 'distribution', distributionInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled">
                  {{ data.description }}
                </mat-checkbox>
              </div>
            </mat-option>
          </ng-container>
        
          <mat-option *ngIf="loading.distribution" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>   

        <mat-error *ngIf="formGroup.controls['distribution'].hasError('notExisting')">
          {{'LABEL_DISTRIBUTION' | translate}} doesn't exist
        </mat-error>
      </mat-form-field>

      <!-- island_group -->
      <mat-form-field class="width-100">
        <mat-chip-list #chipsIslandGroup aria-label="Island Group">
          <mat-chip *ngFor="let data of multiSelect.selectedIslandGroups" [removable]="true" (removed)="toggleSelection(data, filterOptions.island_group, 'selectedIslandGroups', 'island_group')">
            {{data.description}}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        
          <input 
            matInput
            #island_groupInput 
            [matChipInputFor]="chipsIslandGroup" 
            formControlName="island_group" 
            [matChipInputAddOnBlur]="true"
            [matAutocomplete]="island_groupAC" 
            (focus)="getInitialData('island_group')" 
            (blur)="checkAutocompleteObject(formGroup, 'island_group', 'selectedIslandGroups')"
            [placeholder]="'LABEL_ISLAND_GROUP' | translate" 
            >
        
          <mat-icon 
            matSuffix 
            svgIcon="menu-down" 
            *ngIf="!island_groupInput.value" 
            class="autocomplete-arrow-color cursor-pointer"
            (click)="island_groupInput.focus()" 
            >
          </mat-icon>
        </mat-chip-list>
        
        <mat-autocomplete 
          [displayWith]="displayFn"
          #island_groupAC="matAutocomplete" 
          (opened)="autocompleteScroll('island_group','islGrpACRef','islGrpACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.island_group && filterOptions.island_group?.length == 0"
            >
            {{ 'MSG_NO_DATA' | translate }}
          </mat-option>

          <ng-container>
            <mat-option *ngFor="let data of filterOptions.island_group" [value]="data" [disabled]="data.disabled">
              <div (click)="!data.disabled && optionClicked($event, data, filterOptions.island_group, 'selectedIslandGroups', 'island_group', island_groupInput)" [class.disable]="data.disabled">
                <mat-checkbox [checked]="data.selected" (change)="toggleSelection(data, filterOptions.island_group, 'selectedIslandGroups', 'island_group', island_groupInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled">
                  {{ data.description }}
                </mat-checkbox>
              </div>
            </mat-option>
          </ng-container>
        
          <mat-option *ngIf="loading.island_group" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>   

        <mat-error *ngIf="formGroup.controls['island_group'].hasError('notExisting')">
          {{'LABEL_ISLAND_GROUP' | translate}} doesn't exist
        </mat-error>
      </mat-form-field>

      <!-- area -->
      <mat-form-field class="width-100">
        <mat-chip-list #chipsArea aria-label="Area">
          <mat-chip *ngFor="let data of multiSelect.selectedAreas" [removable]="true" (removed)="toggleSelection(data, filterOptions.area, 'selectedAreas', 'area')">
            {{data.description}}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        
          <input 
            matInput
            #areaInput 
            [matChipInputFor]="chipsArea" 
            formControlName="area" 
            [matChipInputAddOnBlur]="true"
            [matAutocomplete]="areaAC" 
            (focus)="getInitialData('area')" 
            (blur)="checkAutocompleteObject(formGroup, 'area', 'selectedAreas')"
            [placeholder]="'LABEL_AREA' | translate" 
            >
        
          <mat-icon 
            matSuffix 
            svgIcon="menu-down" 
            *ngIf="!areaInput.value" 
            class="autocomplete-arrow-color cursor-pointer"
            (click)="areaInput.focus()" 
            >
          </mat-icon>
        </mat-chip-list>
        
        <mat-autocomplete 
          [displayWith]="displayFn"
          #areaAC="matAutocomplete" 
          (opened)="autocompleteScroll('area','areaACRef','areaACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.area && filterOptions.area?.length == 0"
            >
            {{ 'MSG_NO_DATA' | translate }}
          </mat-option>

          <ng-container>
            <mat-option *ngFor="let data of filterOptions.area" [value]="data" [disabled]="data.disabled">
              <div (click)="!data.disabled && optionClicked($event, data, filterOptions.area, 'selectedAreas', 'area', areaInput)" [class.disable]="data.disabled">
                <mat-checkbox [checked]="data.selected" (change)="toggleSelection(data, filterOptions.area, 'selectedAreas', 'area', areaInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled">
                  {{ data.description }}
                </mat-checkbox>
              </div>
            </mat-option>
          </ng-container>
        
          <mat-option *ngIf="loading.area" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>   

        <mat-error *ngIf="formGroup.controls['area'].hasError('notExisting')">
          {{'LABEL_AREA' | translate}} doesn't exist
        </mat-error>
      </mat-form-field>

      <!-- district -->
      <mat-form-field class="width-100">
        <mat-chip-list #chipsDistrict aria-label="District">
          <mat-chip *ngFor="let data of multiSelect.selectedDistricts" [removable]="true" (removed)="toggleSelection(data, filterOptions.district, 'selectedDistricts', 'district')">
            {{data.description}}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        
          <input 
            matInput
            #districtInput 
            [matChipInputFor]="chipsDistrict" 
            formControlName="district" 
            [matChipInputAddOnBlur]="true"
            [matAutocomplete]="districtAC" 
            (focus)="getInitialData('district')" 
            (blur)="checkAutocompleteObject(formGroup, 'district', 'selectedDistricts')"
            [placeholder]="'LABEL_DISTRICT' | translate" 
            >
        
          <mat-icon 
            matSuffix 
            svgIcon="menu-down" 
            *ngIf="!districtInput.value" 
            class="autocomplete-arrow-color cursor-pointer"
            (click)="districtInput.focus()" 
            >
          </mat-icon>
        </mat-chip-list>
        
        <mat-autocomplete 
          [displayWith]="displayFn"
          #districtAC="matAutocomplete" 
          (opened)="autocompleteScroll('district','districtACRef','districtACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.district && filterOptions.district?.length == 0"
            >
            {{ 'MSG_NO_DATA' | translate }}
          </mat-option>

          <ng-container>
            <mat-option *ngFor="let data of filterOptions.district" [value]="data" [disabled]="data.disabled">
              <div (click)="!data.disabled && optionClicked($event, data, filterOptions.district, 'selectedDistricts', 'district', districtInput)" [class.disable]="data.disabled">
                <mat-checkbox [checked]="data.selected" (change)="toggleSelection(data, filterOptions.district, 'selectedDistricts', 'district', districtInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled">
                  {{ data.description }}
                </mat-checkbox>
              </div>
            </mat-option>
          </ng-container>
        
          <mat-option *ngIf="loading.district" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>   

        <mat-error *ngIf="formGroup.controls['district'].hasError('notExisting')">
          {{'LABEL_DISTRICT' | translate}} doesn't exist
        </mat-error>
      </mat-form-field>
      
      <!-- group type -->
      <mat-form-field class="width-100">
        <input 
          matInput
          required
          #groupTypeInput
          formControlName="groupType" 
          [matAutocomplete]="groupTypeAC"
          [placeholder]="'LABEL_GROUP_TYPE' | translate" 
          (focus)="!groupTypeAC.isOpen && getInitialData('groupType')"
          >
    
        <mat-icon 
          matSuffix 
          color="primary"
          class="clear-input"
          svgIcon="close-circle"
          *ngIf="groupTypeInput.value"
          (click)="resetControl(formGroup.get('groupType')); groupTypeInput.value = ''"
          >
        </mat-icon>
    
        <mat-icon 
          matSuffix 
          class="clear-input"
          svgIcon="menu-down"
          *ngIf="!groupTypeInput.value"
          >
        </mat-icon>
    
        <mat-autocomplete 
          [displayWith]="displayFn"
          #groupTypeAC="matAutocomplete" 
          (closed)="groupTypeInput.blur()"
          (opened)="autocompleteScroll('groupType','groupTypeACRef','groupTypeACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.groupType && filterOptions.groupType?.length == 0"
            >
            {{ 'MSG_NO_DATA' | translate }}
          </mat-option>
    
          <mat-option *ngFor="let item of filterOptions.groupType" [value]="item">
            {{ item.description }}
          </mat-option>
    
          <mat-option *ngIf="loading.groupType" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>
    
        <mat-error *ngIf="formGroup.controls['groupType'].hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>   

        <mat-error *ngIf="formGroup.controls['groupType'].hasError('notExisting')">
            {{ 'MSG_DOESNT_EXIST' | translate: {type: ('LABEL_CAMPAIGN' | translate)} }}
        </mat-error>
      </mat-form-field>

      

      <!-- territory -->
      <mat-form-field class="width-100">
        <mat-chip-list #chipsTerritory aria-label="Territory">
          <mat-chip *ngFor="let data of multiSelect.selectedTerritories" [removable]="true" (removed)="toggleSelection(data, filterOptions.territory, 'selectedTerritories', 'territory')">
            {{data.description}}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        
          <input 
            matInput
            #territoryInput 
            [matChipInputFor]="chipsTerritory" 
            formControlName="territory" 
            [matChipInputAddOnBlur]="true"
            [matAutocomplete]="territoryAC" 
            (focus)="getInitialData('territory')" 
            (blur)="checkAutocompleteObject(formGroup, 'territory', 'selectedTerritories')"
            [placeholder]="'LABEL_TERRITORY' | translate" 
            >
        
          <mat-icon 
            matSuffix 
            svgIcon="menu-down" 
            *ngIf="!territoryInput.value" 
            class="autocomplete-arrow-color cursor-pointer"
            (click)="territoryInput.focus()" 
            >
          </mat-icon>
        </mat-chip-list>
        
        <mat-autocomplete 
          [displayWith]="displayFn"
          #territoryAC="matAutocomplete" 
          (opened)="autocompleteScroll('territory','territoryACRef','territoryACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.territory && filterOptions.territory?.length == 0"
            >
            {{ 'MSG_NO_DATA' | translate }}
          </mat-option>

          <ng-container>
            <mat-option *ngFor="let data of filterOptions.territory" [value]="data" [disabled]="data.disabled">
              <div (click)="!data.disabled && optionClicked($event, data, filterOptions.territory, 'selectedTerritories', 'territory', territoryInput)" [class.disable]="data.disabled">
                <mat-checkbox [checked]="data.selected" (change)="toggleSelection(data, filterOptions.territory, 'selectedTerritories', 'territory', territoryInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled">
                  {{ data.description }}
                </mat-checkbox>
              </div>
            </mat-option>
          </ng-container>
        
          <mat-option *ngIf="loading.territory" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>   

        <mat-error *ngIf="formGroup.controls['territory'].hasError('notExisting')">
          {{'LABEL_TERRITORY' | translate}} doesn't exist
        </mat-error>
      </mat-form-field>
    </form>

  </div>
</div>
  
  <div mat-dialog-actions *ngIf="!media.isActive('lt-sm')" fxLayout fxLayoutAlign="end center">
    <button type="button" color="primary" mat-button (click)="applyFilters()"> {{ 'LABEL_APPLY' | translate }} </button>
    <button type="button" color="warn" mat-button (click)="reset()"> {{ 'LABEL_RESET' | translate }} </button>
  </div>
  
  <!-- buttons for mobile view -->
  <div mat-dialog-actions *ngIf="media.isActive('lt-sm')" fxLayout fxLayoutAlign="end center">
    <button type="button" color="primary" mat-icon-button (click)="applyFilters()">
      <mat-icon svgIcon="check"></mat-icon>
    </button>
  
    <button type="button" color="warn" mat-icon-button (click)="reset()">
      <mat-icon svgIcon="restore"></mat-icon>
    </button>
  </div>